export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Tạo Ấn Tượng Chuyên Nghiệp',
      description: 'Xây dựng hình ảnh chuyên nghiệp, đáng tin cậy trong mắt khách hàng và đối tác',
      color: 'teal'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Tăng Độ Nhận Diện',
      description: 'Dễ dàng được tìm thấy trên Google và các nền tảng tìm kiếm với trang cá nhân tối ưu SEO',
      color: 'amber'
    },
    {
      icon: 'ri-team-line',
      title: 'Thu Hút Khách Hàng',
      description: 'Giới thiệu dịch vụ, sản phẩm một cách chuyên nghiệp và thu hút khách hàng tiềm năng',
      color: 'rose'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Khẳng Định Chuyên Môn',
      description: 'Thể hiện kinh nghiệm, thành tựu và chuyên môn của bạn một cách ấn tượng',
      color: 'teal'
    },
    {
      icon: 'ri-share-line',
      title: 'Dễ Dàng Chia Sẻ',
      description: 'Chia sẻ thông tin cá nhân qua link đơn giản thay vì nhiều kênh rời rạc',
      color: 'amber'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Phát Triển Sự Nghiệp',
      description: 'Mở rộng cơ hội nghề nghiệp và kết nối với nhiều đối tác tiềm năng hơn',
      color: 'rose'
    }
  ];

  const colorClasses = {
    teal: {
      bg: 'bg-teal-100',
      text: 'text-teal-600',
      gradient: 'from-teal-500 to-teal-600'
    },
    amber: {
      bg: 'bg-amber-100',
      text: 'text-amber-600',
      gradient: 'from-amber-500 to-amber-600'
    },
    rose: {
      bg: 'bg-rose-100',
      text: 'text-rose-600',
      gradient: 'from-rose-500 to-rose-600'
    }
  };

  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-teal-100 rounded-full mb-6">
            <i className="ri-star-line text-lg text-teal-600"></i>
            <span className="text-sm font-semibold text-teal-700">Lợi Ích Vượt Trội</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Tại Sao Bạn Cần Trang<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-amber-600">
              Thương Hiệu Cá Nhân?
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Trong thời đại số, trang thương hiệu cá nhân là công cụ không thể thiếu để bạn nổi bật và thành công
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const colors = colorClasses[benefit.color as keyof typeof colorClasses];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-2xl group"
              >
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${colors.gradient} rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}